import Button from "../../Framework/Components/Buttons/Button";
import {useEffect} from "react";
import {useClientAccountOverview} from "../../Api/ClientEndpoints";
import {useToasts} from "../../Framework/Providers/ToastsProvider";
import {authConfig, useUKPBAuth} from "../../Providers/AuthProvider";
import {useLocation} from "react-router-dom";

const Login = (props: any) => {
    const { token, error, loggingIn, loggingOut } = useUKPBAuth();

    const location = useLocation();

    const {
        LogIn,
        LogOut,
    } = useUKPBAuth();

    const { addToast } = useToasts();

    const userInfo = useClientAccountOverview();

    const HandleAuthIssue = (error: any) => {
        addToast(`Authorisation: ${error.toString()}`);
        LogOut();
    }

    useEffect(() => {
        if(!loggingOut.current && !token && !loggingIn.current) {
           // LogIn();
        }
    }, []);

    useEffect(() => {
        if(error) {
            HandleAuthIssue(error);
        }
    }, [error]);

    return (
        <div className={'inner-content'}>
            <div className='p-xl'>
                <h1>Sign In</h1>

                <p style={{ whiteSpace: 'pre'}}>CONFIG: {JSON.stringify(authConfig, null, 4)}</p>

                <p style={{ whiteSpace: 'pre'}}>LOCATION: {JSON.stringify(location, null, 4)}</p>

                {error && (
                    <>
                        <p>An error occurred during authentication: {error}</p>
                        <Button title={'Logout'} onClick={() => LogOut()} />
                    </>
                )}

                {!token && (
                    <Button title={'Login'} onClick={() => LogIn()} />
                )}

                {token && (
                    <Button title={'Logout'} onClick={() => LogOut()} />
                )}

                <h5>AUTH DATA:</h5>
                <div>
                    <p>TOKEN: {JSON.stringify(token, null, 2)}</p>
                </div>

                {token && userInfo && (
                    <>
                        <h5>ENDPOINT TEST:</h5>
                        <div>
                            <p>ERROR: {JSON.stringify(userInfo.error, null, 2)}</p>
                            <p>STATUS: {JSON.stringify(userInfo.status, null, 2)}</p>
                            <p>ACTIVE: {JSON.stringify(userInfo.isFetching, null, 2)}</p>
                            <p style={{ whiteSpace: 'pre'}}>DATA: {JSON.stringify(userInfo.data, null, 4)}</p>
                        </div>
                    </>
                )}

            </div>
        </div>
    )
}

export default Login
